
import { Inject, Injectable } from '@angular/core';

import { LaboratoryRefreshInfoCommand, LaboratoryRefreshInfoCommandBase } from '@skylab-shared/business';
import { HttpService } from '@skylab-shared/core';

import { CommandHandlerFor, Http } from '@skylab-angular-shared/core';

@CommandHandlerFor(LaboratoryRefreshInfoCommand)
@Injectable({ providedIn: 'root'})
export class LaboratoryRefreshInfoCommandHandler {
    private commandHandler: LaboratoryRefreshInfoCommandBase;
    public constructor(
        @Inject(Http) http: HttpService
    ) {
        this.commandHandler = new LaboratoryRefreshInfoCommandBase(http);
    }

    public async handleAsync(query: LaboratoryRefreshInfoCommand): Promise<any> {
        return await this.commandHandler.handleAsync(query);
    }
}
